import React, { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { AiOutlineLeftCircle, AiOutlineRightCircle } from 'react-icons/ai';
import { SliderIndicators } from 'src/components/LayourCarousel';

import { BUSINESS_ONBOARDING_STEP } from '.';
import { RewardTutorial1, RewardTutorial2, RewardTutorial3, RewardTutorial4 } from './Components/Images';

const getImage = (key: number) => {
  switch (key) {
    case 0:
      return <RewardTutorial1 />;
    case 1:
      return <RewardTutorial2 />;
    case 2:
      return <RewardTutorial3 />;
    case 3:
      return <RewardTutorial4 />;

    default:
      return null;
  }
};

const steps = [
  {
    title: 'A customer makes a purchase at your business',
    description: (
      <>
        <p>They will automatically receive 5% of the purchase as a rewards credit in their account.</p>
        <p>Rewards can take up to 48 hours to process.</p>
      </>
    ),
  },
  {
    title: 'Customer uses their rewards credit towards a purchase at your business',
    description: (
      <>
        <p>The credit they use will be deposited into your rewards retainer balance.</p>
        <p>
          <span className="font-italic">Coming Soon</span> - You can transfer the balance to your bank at any time!
        </p>
      </>
    ),
  },
  {
    title: 'Where does the rewards credit come from?',
    description: (
      <>
        <p>
          In order to fund customer rewards when they shop at your business, we ask that businesses link a payment
          method to maintain a rewards retainer balance.
        </p>
        <p>
          If your community has sponsored funds, customers’ rewards will draw from these finds first. You will not be
          charged until the sponsored funds deplete.
        </p>
      </>
    ),
  },
  {
    title: 'Maintain a rewards retainer',
    description: (
      <>
        <p>Your account will remain active as long as you maintain a $20 rewards retainer.</p>
        <p>Your balance will be topped up automatically by $50 when it falls below $20.</p>
        <p />
        <span className="font-italic">Coming Soon</span> - Remember, you can transfer your balance to your bank at any
        time.
        <p />
        <p>Now, let’s grow your local business!</p>
      </>
    ),
  },
];

type RewardTutorialProps = {
  setOnboardingStep: (step: BUSINESS_ONBOARDING_STEP) => void;
};

const RewardTutorial: React.FunctionComponent<RewardTutorialProps> = ({ setOnboardingStep }) => {
  const [activeStep, setActiveStep] = useState(0);

  const renderSteps = () => (
    <>
      <Row>
        <Col sm="1" className="d-flex justify-content-end align-items-center text-muted">
          {activeStep ? (
            <span className="c-pointer" onClick={() => setActiveStep(activeStep - 1)}>
              <AiOutlineLeftCircle size="2rem" />
            </span>
          ) : null}
        </Col>
        <Col sm="10">
          <div className="d-flex align-items-center">
            <span>{getImage(activeStep)}</span>
            <div className="ml-3 pl-3">
              <h4 className="text-primary font-weight-bold">{steps[activeStep].title}</h4>
              <span className="text-muted">{steps[activeStep].description}</span>
            </div>
          </div>
        </Col>
        <Col sm="1" className="d-flex align-items-center text-muted">
          {activeStep !== 3 ? (
            <span className="c-pointer" onClick={() => setActiveStep(activeStep + 1)}>
              <AiOutlineRightCircle size="2rem" />
            </span>
          ) : null}
        </Col>
      </Row>
      <div className="mt-3 d-flex flex-column align-items-center">
        <SliderIndicators steps={4} activeStep={activeStep} />
        <Button
          className="mt-2 font-weight-bold text-decoration-none royal-blue-color"
          variant="link"
          onClick={() =>
            activeStep === 3
              ? setOnboardingStep(BUSINESS_ONBOARDING_STEP.ONBOARD_BUSINESS_ADD_BANK)
              : setActiveStep(activeStep + 1)
          }
        >
          <span>{activeStep === 3 ? 'Lets Grow' : 'Next'}</span>
        </Button>
      </div>
    </>
  );

  return (
    <div className="h-100 overflow-auto">
      <div className="m-3 pt-5 mb-5">{renderSteps()}</div>
    </div>
  );
};

export default RewardTutorial;
